import { useTranslation } from 'react-i18next';

const Validation = () => {
  const { t } = useTranslation();

  const emailRegexp = (email: string) => {
    const re =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return re.test(String(email).toLowerCase());
  };

  const phoneRegexp = (phone:string)=>{
    const reg = /^[0-9]*$/
    return reg.test(phone.trim());
  }

  const emailValidation = (email: string) => {
    if (email?.length === 0) {
      return t('enterMail');
    } else if (!emailRegexp(email)) {
      return t('enterCorrectMail');
    }
  };

  const phoneValidation = (phone: string) => {
    if (phone?.length === 0) {
      return t('enterNumber');
    }else if(!phoneRegexp(phone)){
      return t('onlyNumbers');
    }
  };

  const messageValidation = (message: string) => {
    if (message?.length === 0) {
      return t('enterText');
    }
  };

  return {
    emailValidation,
    phoneValidation,
    messageValidation,
  };
};

export default Validation;
